import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import * as jwt_decode from 'jwt-decode';

// General Methods - isUserLoggedIn()

@Injectable({
  providedIn: 'root'
})
export class PreloginService {

  isLoggedInForNav = false;

  private subject = new Subject<any>();

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  // Sidebar toggle on mobile START
  setLoggedInFlagForNav(myFlag) {
    this.isLoggedInForNav = myFlag;
    this.subject.next(this.isLoggedInForNav);
  }

  getLoggedInFlagForNav(): Observable<any> {
    return this.subject.asObservable();
  }
  // Sidebar toggle on mobile END

  // Partner Registration
  registerPartner_Step1(data) {
    return this.http.post<any>(environment.baseUrl + 'register', data, this.httpOptions);
  }

  isDomainAvailable(data) {
    return this.http.post<any>(environment.baseUrl + 'checkDomain', data, this.httpOptions);
  }

  uploadImage(data) {
    console.log(data);
    return this.http.post<any>(environment.baseUrl + 'uploadImage', data);
  }

  removeImage(data) {
    return this.http.post<any>(environment.baseUrl + 'removeImage', data, this.httpOptions);
  }

  registerPartner_Step2(data) {
    return this.http.post<any>(environment.baseUrl + 'register', data, this.httpOptions);
  }

  // Counsellor Registration
  decodeInvitation(data) {
    return this.http.post<any>(environment.baseUrl + 'decodeInvitation', data, this.httpOptions);
  }

  counselorRegistration(data) {
    return this.http.post<any>(environment.baseUrl + 'counselorRegister', data, this.httpOptions);
  }

  // Login
  login(data): Observable<any> {
    return this.http.post<any>(environment.baseUrl + 'login', data, this.httpOptions)
      .pipe(map(data => {
        if (data.statusCode == 200 && data.status == true) {
          localStorage.setItem('pp_session', data.session);
          localStorage.setItem('pp_token', data.token);
          this.setLoggedInFlagForNav(true);
        }
        return data;
      })
      );
  }

  // isLoggedIn for auth
  isUserLoggedIn() {
    if (localStorage.getItem('pp_session') != null) {
      return true;
    }
    else {
      this.setLoggedInFlagForNav(false);
      return false;
    }
  }

  // get logged in user role for auth
  // 0 - Partner, 1 - Admin, 2 - Counsellor
  getCurrentRole() {
    if (localStorage.getItem('pp_session') !== null) {
      const decodedToken = jwt_decode(localStorage.getItem('pp_token'));

      if (decodedToken.partner_id !== null && decodedToken.role === null) {
        return 0;   // Partner
      }
      else if (decodedToken.counselor_id != null) {
        if (decodedToken.role === 1) {
          return 1;   // Admin
        }
        if (decodedToken.role === 2) {
          return 2;   // Counsellor
        }
      }
    }
  }

  resetPassword(data) {
    return this.http.post<any>(environment.baseUrl + 'resetCounselorPassword', data);
  }

}
